module.exports = __webpack_public_path__ + "static/sc_11-547bd0b7b53aa6d328d4e64127192571.jpg";